import axios from 'axios';
import {REP_API_URL} from '../utils/constants.js';

class NewsService {
    async getNewsData(data){
        const url = `${REP_API_URL}get-portal-news/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }

    async getNewsDetails(data,permalink){
        const url = `${REP_API_URL}get-portal-news-detail/${permalink}/`;
        const headers = {
            'Content-Type': 'application/json'
        };
        let formData = data;
        return axios({
            url:url,
            method: 'POST',
            data: formData,
            headers: headers
        }).then(function(response){
            return response;
        }).catch(function(error){
            return error.response;
        });
    }
}

export default NewsService;